import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import { COLORS } from '../../../../constants/styles';
import Icon from '../../../Icon';
import { BUTTONS } from './buttons';
import {
  CHART_FILTERS_TYPE,
  DATA_SOURCE_TYPE,
  VITALS_ACTIVITY_TYPE,
} from '../../constants';
import styles from './index.styl';
import { useSafeDataSourceTitle } from '../../../common/Charts/hooks';

const { YEAR, QUARTER } = CHART_FILTERS_TYPE;
const { DEVICES, CCD } = DATA_SOURCE_TYPE;
const {
  WEIGHT,
  BMI,
  DISTANCE,
  STEPS,
  SATURATION,
  HEIGHT,
  HEART_RATE,
  BLOOD_GLUCOSE,
} = VITALS_ACTIVITY_TYPE;

export const Legend = ({
  sourceType,
  handleClick,
  formatMessage,
  availableDataSource = {},
  dataType,
  activeFilter,
  targetUserFirstName,
  mainUser,
  setSourceType,
}) => {
  const { ccd, devices } = availableDataSource;
  const noAllSources = !ccd || !devices;
  const { getSafeDataSourceTitle } = useSafeDataSourceTitle();

  useEffect(() => {
    if (noAllSources) {
      setSourceType(ccd ? CCD : DEVICES);
    }
  }, [noAllSources]);
  const getIconForDatasetType = (type, color) => {
    switch (dataType) {
      case STEPS:
      case HEIGHT:
      case DISTANCE: {
        return '';
      }
      case BMI:
      case WEIGHT: {
        const isActive = type === sourceType;
        const isDisabled = !availableDataSource[type];
        const getIconWithStatus = () => {
          const forQuarterYear = [QUARTER.type, YEAR.type].includes(
            activeFilter,
          );
          if (isActive) {
            if (type === DEVICES) {
              return 'icon-graph-devices-line-point-white';
            }
            return forQuarterYear
              ? 'icon-graph-health-record-line-point-white'
              : 'icon-graph-health-record-point-white';
          }
          if (isDisabled) {
            if (type === DEVICES) {
              return 'icon-graph-devices-line-point-disable';
            }
            return forQuarterYear
              ? 'icon-graph-health-record-line-point-disable'
              : 'icon-graph-health-record-point-disable';
          }
          if (type === DEVICES) {
            return 'icon-graph-devices-line-point-black';
          }
          return forQuarterYear
            ? 'icon-graph-health-record-line-orange'
            : 'icon-graph-health-record-point-orange';
        };
        return (
          <Icon className={styles.icon} size={24} name={getIconWithStatus()} />
        );
      }
      case HEART_RATE:
      case SATURATION:
      case BLOOD_GLUCOSE: {
        return (
          <div
            className={styles.itemColor}
            style={{
              backgroundColor: color,
              ...(type === sourceType && { backgroundColor: COLORS.white }),
              ...(!availableDataSource[type] && {
                backgroundColor: COLORS.stormyBlue,
              }),
            }}
          />
        );
      }
    }
  };
  return (
    <div className={styles.root}>
      {BUTTONS.map(({ type, color }) => (
        <div
          className={cn(styles.itemWrapper, {
            [styles.activeItem]: type === sourceType,
            [styles.disabled]: !availableDataSource[type],
            [styles.activeItemNoAction]: type === sourceType && noAllSources,
          })}
          onClick={() => handleClick(type)}
          key={type}
        >
          {getIconForDatasetType(type, color)}
          <div
            className={cn(styles.itemTitle, {
              [styles.itemTitleActive]: type === sourceType,
              [styles.itemDisableTitle]: !availableDataSource[type],
            })}
          >
            {getSafeDataSourceTitle(
              type,
              formatMessage,
              mainUser,
              targetUserFirstName,
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

Legend.propTypes = {
  handleClick: PropTypes.func,
  sourceType: PropTypes.string,
  formatMessage: PropTypes.func,
  dataType: PropTypes.string,
  activeFilter: PropTypes.string,
  availableDataSource: PropTypes.object,
  mainUser: PropTypes.bool,
  targetUserFirstName: PropTypes.string,
  setSourceType: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/Legend/index.jsx